import { render, staticRenderFns } from "./PFSettlementEmployeeDetailsFront.vue?vue&type=template&id=44ad74bc"
import script from "./PFSettlementEmployeeDetailsFront.vue?vue&type=script&lang=js"
export * from "./PFSettlementEmployeeDetailsFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports